module.exports = __webpack_public_path__ + "img/device_1002_1_select.49e4a259.svg";